export const webview = {
  webviewContent: '이것은 외부 URL이며 새 창에서 열립니다. 열까요?',
  webviewButtonOpenTitle: '열기',
  webviewButtonCopyTitle: 'URL 복사',
  webviewButtonOpenAgainTitle: '다시 열기',
  notifications: {
    urlCopied: 'URL 이 복사되었습니다!'
  }
}
